export class Specialization {
  id: string;
  name: string;
  disabledForClients: boolean;
}
